module.exports = __webpack_public_path__ + "img/user-headset.482af648.svg";